import React from 'react';

// PropTypes
import PropTypes from 'prop-types';

// Local Components
import DateTimeAccordion from '../FormFields/DateTimeAccordion';

// Utils Date Formatter
import { formatEventDate } from '../../utils/dateFormatter';

// Typography
import { H5, Body2, Body3, H6 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/EventSchedule.css';

const eventSchedule = {
    days: [
        {
            date: '2024-11-20',
            startTime: '09:00',
            endTime: '12:00',
            slots: [
                {
                    slotName: 'Slot 1',
                    slotStartTime: '09:00',
                    slotEndTime: '10:00'
                },
                {
                    slotName: 'Slot 2',
                    slotStartTime: '10:00',
                    slotEndTime: '11:00'
                },
                {
                    slotName: 'Slot 3',
                    slotStartTime: '11:00',
                    slotEndTime: '12:00'
                }
            ]
        },
        {
            date: '2024-11-20',
            startTime: '09:00',
            endTime: '12:00',
            slots: []
        }
    ]
};

export default function EventSchedule({ eventSchedules = eventSchedule.days }) {
    return (
        eventSchedules && (
            <div className="event-date-schedule-details-container">
                {/* Event Schedule Title */}
                <H5 fontWeight={600}>Event Schedule</H5>

                {eventSchedules.map((event, index) => (
                    <React.Fragment key={index}>
                        {/* Event Schedule Section With Slot */}
                        {event.slots.length > 0 ? (
                            <section className="event-schedule-detail-section">
                                <DateTimeAccordion
                                    eventDateTitle={`${formatEventDate(event.date)}`}
                                    eventTimeTitle={`${event.startTime} - ${event.endTime}`}
                                >
                                    <div className="event-schedule-timing">
                                        {event.slots.map((slot, slotIndex) => (
                                            <div
                                                className="event-slot-schedule-details"
                                                key={slotIndex}
                                            >
                                                <Body2>{`${slot.slotName}: ${slot.slotStartTime} - ${slot.slotEndTime}`}</Body2>
                                            </div>
                                        ))}
                                    </div>
                                </DateTimeAccordion>
                            </section>
                        ) : (
                            /* Event Schedule Section Without Slot */
                            <section className="event-schedules-no-slot-section">
                                <div
                                    style={{
                                        borderRadius: '20px',
                                        background:
                                            'linear-gradient(to top left, #0A1528, #1D3A6E)',
                                        padding: '8px 16px',
                                        color: '#FFFFFF'
                                    }}
                                >
                                    <H6 color="#F8A21E">{`${formatEventDate(event.date)}`}</H6>
                                    <Body3>{`${event.startTime} - ${event.endTime}`}</Body3>
                                </div>
                            </section>
                        )}
                    </React.Fragment>
                ))}
            </div>
        )
    );
}

// PropTypes Validation
EventSchedule.propTypes = {
    eventSchedules: PropTypes.array.isRequired
};
